import { IonContent, IonPage, IonButton, IonInput } from "@ionic/react";
import { Icon, LockIcon, UserIcon } from "evergreen-ui";
import { useContext, useState, useEffect } from "react";
import { globalContext } from "../../global/Store";
import { Lookup, User, Development } from "../../global/Types";
import {
  LogoGroup,
  LoginForm,
  Logo,
  UsernameGroupColumn,
  UsernameGroup,
  PasswordGroup,
  UsernameGroupColumnFiller,
  ButtonOverlay,
  BtnLoginText,
} from "./forgotPasswordStyle";
import { dataRepoContext } from "../../data-repo/DataRepo";

export const ForgotPassword = () => {

  const { globalState, dispatch, globalFunctions } = useContext(globalContext);
  const { globalDataRepo } = useContext(dataRepoContext);
  const [username, setUsername] = useState<string | null | undefined>("");
  const [passwordSetSuccess, setPasswordSetSuccess] = useState(false);

  const validateForm = () => {

    var _validation = { status: false, message: '' }

    if (!!username && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(username)) {
      _validation.status = true;
      _validation.message = '';
    } else {
      _validation.status = false;
      _validation.message = 'Email is not valid';
    }

    return _validation;

  }

  const handleSetPassword = () => {

    var _validationResult = validateForm();

    if (_validationResult.status === true && !!username) {

      globalDataRepo.RequestPasswordReset(username.trim()).then(
        function (response: any) {
          setPasswordSetSuccess(true);
        },
        function (error: any) {
          setPasswordSetSuccess(true);
        }
      );

      
    }

    if (_validationResult.status === false) {
      globalFunctions.HandleToast({
        header: "Error",
        id: "Set-Password-Error",
        description: _validationResult.message,
        type: "danger",
        error: '',
      });
    }
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      handleSetPassword();
    }
  }

  return (
    <IonPage>
      <IonContent style={{ "--background": "white" }}>
        <LogoGroup style={{ marginTop: "120px", width: "100%" }}>
          <Logo src={"../../assets/encompassicon/Encompass.png"}></Logo>
        </LogoGroup>
        <LoginForm>

        { !passwordSetSuccess ? 
          <>
          <UsernameGroupColumn>
            <UsernameGroup>
              <Icon
                icon={UserIcon}
                size={20}
                style={{
                  color: "white",
                  marginTop: "18px",
                  marginLeft: "10px",
                }}
              />
              <IonInput
                type="text"
                className="login-input"
                placeholder="Email"
                style={{
                  color: "#ff0000",
                  marginLeft: "10px",
                  boxShadow: "none",
                }}
                value={username}
                onIonChange={(event) => setUsername(event.detail.value)}
                onKeyDown={handleKeyDown}
              //   autocomplete="off"
              //   onfocusout="this.removeAttribute('readonly');"
              //   onfocus="this.setAttribute('readonly','readonly');"
              ></IonInput>
            </UsernameGroup>
          </UsernameGroupColumn>
          <IonButton className="jm-ion-btn" onClick={handleSetPassword}>
            <ButtonOverlay>
              <BtnLoginText>Request Password Reset</BtnLoginText>
            </ButtonOverlay>
          </IonButton></> 
          :

            <div style={{textAlign: "left", width: "300px"}}>
            <p>If your email address is on our system, you will receive an email with a link to reset your password.</p>
            </div>

           }
        </LoginForm>
      </IonContent>
    </IonPage>
  );
};
